var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',{staticClass:"h-10 bg-gray-200"},[_vm._l((_vm.list),function(item,i){return [_c('th',{key:i,staticClass:"text-xs font-medium border border-gray-300"},[_vm._v(_vm._s(item))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }